import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConstantValues } from '../bpg-common/models/bpg-constants';
import { map, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import {BpgCommonService} from '../bpg-common/services/bpg-common.service';


@Injectable({
  providedIn: 'root'
})
export class BpgExpensesService {

  constructor(private readonly http:HttpClient,
    private readonly bpgCommonService:BpgCommonService) { }

    URI : string = ConstantValues.eventManagementApiUrl.eventManagementUrl;
    userUrl : string = ConstantValues.userManagementApiUrl.userManagementUrl;
    createExpenseApi : string = ConstantValues.eventManagementApiUrl.createExpense;
    getExpenseApi : string = ConstantValues.eventManagementApiUrl.getExpense;
    getExpenseByIdApi : string = ConstantValues.eventManagementApiUrl.getExpenseById;
    expenseStatusUpdateApi : string = ConstantValues.eventManagementApiUrl.expenseStatusUpdate;
    getSitePrimaryContactSuperAdminApi : string = ConstantValues.eventManagementApiUrl.getSitePrimaryContactSuperAdmin;


     /** For service call to save event
   * @class BpgExpensesService
   * @method saveExpense
   * @param expenseFormData
   * @returns Observable
   */

  public saveExpense(expenseFormData:any): Observable<any> {

    return this.http.post(this.URI+this.createExpenseApi,expenseFormData,this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

      })).pipe(catchError((error: any) => {
        throw of(error);
    }))

  }

       /** For service call to get expense list
   * @class BpgExpensesService
   * @method getExpenses
   * @param landingDTO
   * @returns Observable
   */

  public getExpenses(landingDTO:any): Observable<any> {

    return this.http.post(this.URI+this.getExpenseApi,landingDTO,this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

      })).pipe(catchError((error: any) => {
        throw of(error);
    }))

  }
  
    /** For service call to update expense status
   * @class BpgExpensesService
   * @method updateExpenseStatus
   * @param landingDtoModel
   * @returns Observable
   */

  public updateExpenseStatus(landingDtoModel): Observable<any> {
    return this.http.post(this.URI+this.expenseStatusUpdateApi, landingDtoModel,this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

      })).pipe(catchError((error: any) => {
        throw of(error);
    }))
}

/** For service call to get site primary contact super admin
   * @class BpgExpensesService
   * @method getSitePrimaryContactAdmins
   * @param siteId , userId
   * @returns Observable
   */

  public getSitePrimaryContactAdmins(sitePrimaryContactDTO): Observable<any> {
    return this.http.post(this.URI+this.getSitePrimaryContactSuperAdminApi, sitePrimaryContactDTO,this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

      })).pipe(catchError((error: any) => {
        throw of(error);
    }))
}

       /** For service call to get expense list
   * @class BpgExpensesService
   * @method getExpenses
   * @param landingDTO
   * @returns Observable
   */

       public getExpenseById(expenseId:any): Observable<any> {

        return this.http.get(this.URI+this.getExpenseByIdApi+expenseId,this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
          return data;
    
          })).pipe(catchError((error: any) => {
            throw of(error);
        }))
    
      }
}